export const selectorPauseroll = ({ pauseroll }) => pauseroll;
export const selectorAdPauserollable = ({ markers: { pub: { pauseroll: { enabled } } } }) => enabled;
export const selectorArrayNotEmpty = (items) => Boolean(items.length);
export const selectorOk = ({ ok }) => ok;
export const selectorCappingPreroll = ({ markers: { pub: { pauseroll: { cappingPreroll } } } }) => cappingPreroll;
export const selectorCappingPauseroll = ({ markers: { pub: { pauseroll: { cappingPauseroll } } } }) => cappingPauseroll;
export const selectorPauserollDelay = ({ markers: { pub: { pauseroll: { delay } } } }) => delay;
export const selectorIsAd = ({ isAd }) => isAd;
export const selectorReachable = ({ adBlocked }) => !adBlocked;
